import { render, staticRenderFns } from "./SvgRecord.vue?vue&type=template&id=7c790f4f&"
import script from "./SvgRecord.vue?vue&type=script&lang=js&"
export * from "./SvgRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports